import {useContext} from "react";
import FlowContext from "../context/FlowContext";

const BackCircle = () => {
    const {historyObj, goBack} = useContext(FlowContext);

    return(
        <div className="circle back-circle" onClick={goBack}>
            <div className="circle-content">
                <div className="icon width-25">
                    <img src={`https://fdrive.in//test-img/${historyObj[historyObj.length - 1].img}`} alt=""/>
                </div>
                <div className="name font-15">{historyObj[historyObj.length - 1].name}</div>
            </div>
        </div>
    )
}

export default BackCircle;
